function e(e,t){if(t===void 0){let t=new Set(e);return e=>t.has(e)}return t.includes(e)}export{e as isIncludedIn};
//# sourceMappingURL=isIncludedIn-DOY61LSc.js.map